import { useState } from 'react';

import PropTypes from 'prop-types';

import ErrorMessage from '../../../../../Components/Errors/ErrorMessage';
import RemoveModal from '../../../../../Components/Modal/RemoveModal';
import { useRole } from '../../../../../Hooks/Role';
import { serverErrorHandler } from '../../../../../Utils/Helpers';
import { checkType } from '../../../Utils/Helpers';
import LeagueList from './LeagueList';
import Search from './Search';
import SearchResult from './SearchResult';
import TeamList from './TeamList';
import UsersList from './UsersList';

const Step1 = ({ get, success, navigate, error, context, errors }) => {
  const [loading, setLoading] = useState(false);
  const { can } = useRole();
  const [serverErrors, setServerErrors] = useState({});
  const [listLoading, setListLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [teamAddUserLoaidng, setTeamAddUserLoaidng] = useState(false);
  const [leagueAddUserLoaidng, setLeagueAddUserLoaidng] = useState(false);
  const [type, setType] = useState(1);
  const [team, setTeam] = useState(undefined);
  const [league, setLeague] = useState(undefined);

  const onSubmit = async (values) => {
    setServerErrors({});
    setLoading(true);
    await get(
      `/user/search/${values.nat_code}?competition_id=${context?.competition?.id}`,
      (res) => {
        const { data } = res;
        if (
          context.competition?.gender != data?.gender &&
          context.competition?.gender != 2
        ) {
          setLoading(false);
          return error('جنسیت شرکت کننده با جنسیت مسابقه یکسان نیست');
        }
        context.user = data;
        setType(1);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        if (err?.status === 422 || err.status === 400) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('دریافت اطلاعات با خطا روبرو شد.');
        }
      },
    );
  };

  const addUserToList = async () => {
    if (
      !can('Super Admin') &&
      context.users?.length >=
        context?.competition?.provinces[0]?.pivot?.single_count
    ) {
      return error(`
      تعداد شرکت کنندگان انفرادی برای استان  
      ${context?.competition?.provinces[0]?.name}
      ${context?.competition?.provinces[0]?.pivot?.single_count}
      می باشد.
      `);
    }
    setListLoading(true);
    const users = [...context?.users];
    if (users.length > 0) {
      const user = users?.findIndex((u) => u.id === context?.user?.id);
      if (user !== -1) {
        setListLoading(false);
        return error('کاربر قبلا به لیست اضافه شده است.');
      }
    }

    await users.push(context?.user);
    context.users = users;
    context.user = {};
    setListLoading(false);
  };

  const removeUserFromList = async (id) => {
    setListLoading(true);
    const users = [...context.users];
    const usersFilter = await users.filter((u) => u.id !== id);
    context.users = usersFilter;
    setModalIsOpen(false);
    setListLoading(false);
  };

  const addToTeam = async () => {
    setTeamAddUserLoaidng(true);
    if (team === undefined) {
      setTeamAddUserLoaidng(false);
      return error('لطفا ابتدا تیم را اضافه کنید.');
    }

    const teams = [...context.teams];
    let teamIndex = teams.findIndex((t) => t?.id == team);

    if (
      !can('Super Admin') &&
      context.teams[teamIndex]?.users?.length >=
        context?.competition?.provinces[0]?.pivot?.team_count
    ) {
      return error(`
      تعداد شرکت کنندگان تیم برای استان  
      ${context?.competition?.provinces[0]?.name}
      ${context?.competition?.provinces[0]?.pivot?.team_count}
      می باشد.
      `);
    }

    if (teams[teamIndex]?.users === undefined) {
      teams[teamIndex]['users'] = await [context?.user];
    } else {
      if (
        teams[teamIndex]?.['users']?.findIndex(
          (u) => u.id == context?.user?.id,
        ) !== -1
      ) {
        setTeamAddUserLoaidng(false);
        return error('کاربر قبلا به تیم اضافه شده است.');
      }
      await teams[teamIndex]['users'].push(context.user);
    }
    context.teams = teams;
    context.user = {};
    setTeamAddUserLoaidng(false);
  };

  const addToLeague = async () => {
    setLeagueAddUserLoaidng(true);
    if (league === undefined) {
      setLeagueAddUserLoaidng(false);
      return error('لطفا ابتدا تیم را به لیگ اضافه کنید.');
    }

    const leagues = [...context.leagues];
    let leagueIndex = leagues.findIndex((t) => t?.id == league);

    if (
      !can('Super Admin') &&
      context.league[leagueIndex]?.users?.length >=
        context?.competition?.provinces[0]?.pivot?.league_count
    ) {
      return error(`
      تعداد شرکت کنندگان لیگ هر تیم برای استان  
      ${context?.competition?.provinces[0]?.name}
      ${context?.competition?.provinces[0]?.pivot?.league_count}
      می باشد.
      `);
    }

    if (leagues[leagueIndex]?.users === undefined) {
      leagues[leagueIndex]['users'] = await [context?.user];
    } else {
      if (
        leagues[leagueIndex]?.['users']?.findIndex(
          (u) => u.id == context?.user?.id,
        ) !== -1
      ) {
        setLeagueAddUserLoaidng(false);
        return error('کاربر قبلا به تیم اضافه شده است.');
      }

      await leagues[leagueIndex]['users'].push(context.user);
    }

    //for check league or teams competition in database
    leagues[leagueIndex]['competition_league'] = 1;

    context.leagues = leagues;
    context.user = {};
    setLeagueAddUserLoaidng(false);
  };
  return (
    <>
      <Search
        loading={loading}
        onSubmit={onSubmit}
        serverErrors={serverErrors}
      />
      <div className='row'>
        <SearchResult
          addToTeam={addToTeam}
          addUserToList={addUserToList}
          addToLeague={addToLeague}
          context={context}
          loading={loading}
          setTeam={setTeam}
          setLeague={setLeague}
          setType={setType}
          type={type}
        />
        {checkType(context, 'انفرادی') && (
          <>
            <UsersList
              context={context}
              loading={listLoading}
              setModalIsOpen={setModalIsOpen}
              setModalRemoveObject={setModalRemoveObject}
              errors={errors}
            />
            <ErrorMessage
              error={errors?.single?.fillError}
              classes='mx-3 f-14'
            />
          </>
        )}
        {checkType(context, 'تیمی') && (
          <>
            <TeamList
              context={context}
              teamAddUserLoaidng={teamAddUserLoaidng}
              errors={errors}
            />
            <ErrorMessage error={errors?.team?.fillError} classes='mx-3 f-14' />
          </>
        )}

        {checkType(context, 'لیگ') && (
          <>
            <LeagueList
              context={context}
              leagueAddUserLoaidng={leagueAddUserLoaidng}
              errors={errors}
            />
            <ErrorMessage
              error={errors?.league?.fillError}
              classes='mx-3 f-14'
            />
          </>
        )}
      </div>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeUserFromList}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف کاربر "${modalRemoveObject?.name} ${modalRemoveObject?.last_name}" مطمئن هستید ؟`}
      />
    </>
  );
};

Step1.propType = {
  get: PropTypes.func,
  success: PropTypes.func,
  navigate: PropTypes.func,
  error: PropTypes.func,
  context: PropTypes.object,
  errors: PropTypes.object,
};

export default Step1;
